import { effectiveFxRates } from '../../shared/fx-rates.js';

/** Build the replacement rate map without changing any other configured currency. */
export function currencyRatesWithChange(
  assumptions: Record<string, unknown>,
  code: string,
  rate: number | null,
): Record<string, number> {
  const current = effectiveFxRates(assumptions);
  return Object.fromEntries(
    Object.entries(current)
      .filter(([key]) => key !== code)
      .concat(rate === null ? [] : [[code, rate]]),
  );
}
